import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VeeValidate from 'vee-validate';
import Notifications from 'vue-notification';
import * as ModalDialogs from 'vue-modal-dialogs';
import axios from 'axios';
import { __, capitalize } from '@/helpers/utils';

Vue.config.productionTip = false;

/* *** TOTO BY BOLO NAJLEPSIE PRESUNUT DO SAMOSTATNEHO SUBORU *** */

// VeeValidate.Validator.extend('adult', {
//     getMessage: () => {
//         return 'Musíte byť starší ako 18 rokov';
//     },
//     validate: (value: string) => {
//         console.log(value);
//
//         return false;
//     }
// });

VeeValidate.Validator.extend('phone', {
    getMessage: () => {
        return 'Zlý tvar tel. čísla';
    },
    validate: (value: string) => {
        if (value.length !== 13) {
            return false;
        };

        return true;
    }
});

const dict = {
    en: {
        messages: {
            min: (field: string, args: Array<string>) => `Pole ${__(field)} musí byť dlhšie ako ${args[0]}`,
            required: (field: string) => `${capitalize(__(field))} je povinné pole`
        },
        custom: {
            email: {
                email: 'Email nie je v správnom tvare'
            }
        }
    }
};

/* ************************************************************** */

VeeValidate.Validator.localize(dict);

Vue.use(VeeValidate);
Vue.use(Notifications);
Vue.use(ModalDialogs);

new Vue({
    router,
    store,
    render: (h) => h(App),
    created() {
        if (this.$store.getters.isLoggedIn) {
            axios.defaults.headers.common.Authorization = 'Bearer ' + this.$store.getters.token;
        }
    },
}).$mount('#app');
